"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GigyaAccountType = exports.GigyaWebhookEventType = void 0;
var GigyaWebhookEventType;
(function (GigyaWebhookEventType) {
    GigyaWebhookEventType["accountCreated"] = "accountCreated";
    GigyaWebhookEventType["accountRegistered"] = "accountRegistered";
    GigyaWebhookEventType["accountUpdated"] = "accountUpdated";
    GigyaWebhookEventType["accountDeleted"] = "accountDeleted";
    GigyaWebhookEventType["accountLoggedIn"] = "accountLoggedIn";
    GigyaWebhookEventType["accountLockedOut"] = "accountLockedOut";
    GigyaWebhookEventType["accountMerged"] = "accountMerged";
    GigyaWebhookEventType["accountProgressed"] = "accountProgressed";
    GigyaWebhookEventType["accountUidChanged"] = "accountUidChanged";
    GigyaWebhookEventType["sitePreferencesReset"] = "sitePreferencesReset";
    GigyaWebhookEventType["subscriptionUpdated"] = "subscriptionUpdated";
    GigyaWebhookEventType["organizationRequested"] = "organizationRequested";
    GigyaWebhookEventType["organizationEnteredDraftStage"] = "organizationEnteredDraftStage";
    GigyaWebhookEventType["organizationEnteredApprovalWorkflow"] = "organizationEnteredApprovalWorkflow";
    GigyaWebhookEventType["organizationActivated"] = "organizationActivated";
    GigyaWebhookEventType["organizationSuspended"] = "organizationSuspended";
    GigyaWebhookEventType["organizationRejected"] = "organizationRejected";
    GigyaWebhookEventType["organizationWorkflowEnabled"] = "organizationWorkflowEnabled";
})(GigyaWebhookEventType = exports.GigyaWebhookEventType || (exports.GigyaWebhookEventType = {}));
var GigyaAccountType;
(function (GigyaAccountType) {
    GigyaAccountType["full"] = "full";
    GigyaAccountType["lite"] = "lite";
})(GigyaAccountType = exports.GigyaAccountType || (exports.GigyaAccountType = {}));
